import Modal from 'react-modal';
import { LoadingSection } from "commonsComponents/loadingSection"

export const DocumentModalLoading = ({ isLoading }) => {
    return (
        <Modal
            isOpen={isLoading}
            style={{
                overlay: {
                    zIndex: 2101
                },
            }}
        >
            <div className='documents__modal__box-inside'>
                <div className='documents__modal-loading-body'>
                    <LoadingSection />
                </div>
            </div>
        </Modal>

    )
}